import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Route, NavLink, Routes, Redirect } from "react-router-dom"
import { Layout, Menu } from "antd"
import {
  DashboardOutlined,
  CommentOutlined,
  InfoCircleOutlined,
  BgColorsOutlined,
} from "@ant-design/icons"

import Header from "./Header"
import Dashboard from "./Dashboard"
import Categories from "./Categories"
import Tickets from "./Tickets"
import Posts from "./Posts"

import ROLES from "../../_shared/constants/roles.js"
import { useStateValue } from "../../_shared/context/AppStateStore"

// ----------------------------------------------------------------------------

const { Content, Footer, Sider } = Layout

// ----------------------------------------------------------------------------

function LoggedApp(props) {
  const appState = useStateValue()
  const [{ user }, dispatch] = appState
  const { match } = props



  const renderRoutedContent = () => {
    return (
      <Routes>
        <Route path="/" exact element={<Dashboard />} />
        <Route path="/categories" exact element={<Categories />} />
        <Route path="/tickets" exact element={<Tickets />} />
        <Route path="/posts" exact element={<Posts />} />
      </Routes>
    )
  }

  const MENU_ITEMS = [
    {
      link: "/",
      icon: <DashboardOutlined />,
      title: "Home",
    },
    {
      link: "/categories",
      icon: <BgColorsOutlined />,
      title: "Categorie",
    },
    {
      link: "/tickets",
      icon: <CommentOutlined />,
      title: "Supporto online",
      expert_role: true,
    },
    {
      link: "/posts",
      icon: <InfoCircleOutlined />,
      title: "Vebi informa",
    },
  ]

  const renderMenuItems = () => {
    return MENU_ITEMS.filter((item) => {
      if (user && user.role == ROLES.EXPERT) {
        return item.expert_role
      }
      return true
    }).map((item) => {
      return (
        <Menu.Item key={item.link}>
          <NavLink to={item.link}>
            {item.icon}
            <span className="menu-text">{item.title}</span>
          </NavLink>
        </Menu.Item>
      )
    })
  }

  return (
    <div className={props.className}>
      <Layout>
        <Sider className="sidebar" breakpoint="lg" collapsedWidth="0">
          <div className="logo" />
          <Menu theme="dark" mode="inline">
            {renderMenuItems()}
          </Menu>
        </Sider>
        <Layout>
          <Header />
          <div className="main-container">
            <Content>{renderRoutedContent()}</Content>
            <Footer style={{ textAlign: "center" }}>
              Vebi Istituto Biochimico s.r.l. © {new Date().getFullYear()}
            </Footer>
          </div>
        </Layout>
      </Layout>
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

LoggedApp.propTypes = {
  className: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired, // from router
  location: PropTypes.object.isRequired, // from router
}

LoggedApp.defaultProps = {}

// ----------------------------------------------------------------------------
// Styled wrapper
// ----------------------------------------------------------------------------

const StyledLoggedApp = styled(LoggedApp)`
  /* GENERAL APP STYLES */

  * {
    color: ${(props) => props.theme.colors.textColor};
  }

  /* ------------------ */
  & {
    min-height: 100vh;
    max-height: 100vh;
    min-width: 100vw;
    overflow-x: hidden;
    background-color: ${(props) => props.theme.colors.primaryBackgroundColor};

    .ant-layout {
      min-height: 100vh;
      max-height: 100vh;

      background-color: ${(props) => props.theme.colors.primaryBackgroundColor};

      aside {
        background-color: ${(props) =>
    props.theme.colors.secondaryBackgroundColor};

        .logo {
          box-sizing: border-box;
          padding: 20px;
          min-height: 150px;

          background-image: url(${require("../../_shared/images/logo.png")});
          background-size: contain;
          background-repeat: no-repeat;
          background-origin: content-box;
          background-position: center center;
        }

        .ant-menu {
          margin-top: 50px;
          background-color: transparent;

          .ant-menu-item {
            position: relative;
            padding-left: 22px;
            padding-right: 0;

            a {
              padding-left: 22px;
              color: ${(props) => props.theme.colors.textPrimaryColor};

              .anticon {
                * {
                  color: ${(props) => props.theme.colors.textPrimaryColor};
                }
              }

              :hover {
                text-decoration: none;
              }
            }

            .menu-text {
              color: ${(props) => props.theme.colors.textPrimaryColor};
              font-weight: normal;
            }
          }

          .ant-menu-item:active {
            background: none;
          }

          .ant-menu-item-selected {
            position: relative;
            background-color: transparent;
            overflow: visible;
            height: 40px;

            ::before,
            ::after {
              content: "";
              position: absolute;
              width: 24px !important;
              height: 24px !important;
              right: 0px;
            }

            ::before {
              bottom: -24px;
              width: 24px !important;

              background: radial-gradient(
                circle at bottom left,
                transparent 24px,
                ${(props) => props.theme.colors.primaryBackgroundColor} 25px
              );
            }

            ::after {
              transition: none;
              top: -24px;
              background: radial-gradient(
                circle at top left,
                transparent 24px,
                ${(props) => props.theme.colors.primaryBackgroundColor} 25px
              );
            }

            .current-route {
              border-top-left-radius: 22px;
              border-bottom-left-radius: 22px;

              background: ${(props) =>
    props.theme.colors.primaryBackgroundColor};

              .anticon {
                * {
                  color: ${(props) => props.theme.colors.textColor};
                }
              }

              .menu-text {
                font-weight: 600;
                color: ${(props) => props.theme.colors.textColor};
              }
            }
          }
        }
      }

      .main-container {
        display: flex;
        flex-direction: column;

        height: 100%;

        overflow-y: auto;

        main {
          flex: 1;
          padding: 24px;
          height: auto;
          min-height: auto;
        }

        footer {
          padding: 10px;
          background-color: transparent;
          color: #7f8fa4;
          font-size: 10px;
        }
      }
    }
  }
`
export default StyledLoggedApp
